<template>
  <div class="frame-wrapper paddy-field-show">
    <div class="filter-area-left">
      <div class="filter-icon-paddy" @click="onClickArea"></div>
    </div>
    <div
      v-if="selectedPaddyField"
      class="center-frame-container"
    >
      <transition name="scale" @after-leave="selectedPaddyField = null" appear>
        <div v-if="!isCenterFrameHidden" class="center-frame">
          <div class="title-area">
            <h3>
              <span :class="[classTitleObject]"></span
              >{{ this.selectedPaddyField.name }}
            </h3>
            <div class="btn-close" @click="hideCenterFrame"></div>
          </div>

          <div id="edit-area" v-if="!isCenterFrameEdit">
            <span :class="{ active: !isReadOnly, disabled: isReadOnly }" @click="onEdit">編集する</span>
          </div>

          <validation-observer ref="obs" v-slot="ObserverProps">
            <section class="section">
              <div class="container">
                <dl class="columns">
                  <template v-if="isCenterFrameEdit">
                    <dt>名前</dt>
                    <dd>
                      <ValidationProvider
                        rules="max:100"
                        v-slot="ProviderProps"
                      >
                        <input v-model="form.name" type="text" />
                        <div class="validation-error">
                          {{ ProviderProps.errors[0] }}
                        </div>
                      </ValidationProvider>
                    </dd>
                    <dt>位置</dt>
                    <dd>
                      <!--input v-model="form.map_pos" type="text" /-->
                      <span>{{ selectedPaddyField.map_pos }}</span>
                    </dd>
                    <dt>面積</dt>
                    <dd>
                      <ValidationProvider
                        rules="customDoubleTwo"
                        v-slot="ProviderProps"
                        class="input-with-unit"
                      >
                        <input v-model="form.area" type="text" /><span
                          class="unit"
                          >a</span
                        >
                        <div class="validation-error">
                          {{ ProviderProps.errors[0] }}
                        </div>
                      </ValidationProvider>
                    </dd>
                    <dt>品種</dt>
                    <dd>
                      <ValidationProvider rules="max:20" v-slot="ProviderProps">
                        <select v-model="form.brand_id">
                          <option disabled value="">
                            品種を選択してください
                          </option>
                          <option
                            v-for="brand in brands"
                            :key="brand.brand_id"
                            :value="brand.brand_id"
                          >
                            {{ brand.brand_name }}
                          </option>
                        </select>
                        <!-- <input
                          v-model="form.brand"
                          type="text"
                          list="brand_list"
                        />
                        <datalist id="brand_list">
                          <option
                            v-for="(optItem, index) in brands"
                            :key="index"
                          >
                            {{ optItem.brand_name }}
                          </option>
                        </datalist> -->
                        <div class="validation-error">
                          {{ ProviderProps.errors[0] }}
                        </div>
                      </ValidationProvider>
                    </dd>
                    <dt>耕作者</dt>
                    <dd>
                      <ValidationProvider
                        rules="max:100"
                        v-slot="ProviderProps"
                      >
                        <input
                          v-model="form.kousakusha"
                          type="text"
                          list="user_list"
                        />
                        <datalist id="user_list">
                          <option
                            v-for="(optItem, index) in selectOptions"
                            :key="index"
                          >
                            {{ optItem }}
                          </option>
                        </datalist>
                        <div class="validation-error">
                          {{ ProviderProps.errors[0] }}
                        </div>
                      </ValidationProvider>
                    </dd>
                    <dt>ピンアイコン</dt>
                    <dd>
                      <div
                        v-for="image in pins"
                        :key="image"
                        class="image-radio-button"
                        :style="{
                          background:
                            image == form.pin_type ||
                            (!form.pin_type && image == 'ricelog_pinicon_040')
                              ? '#ddd'
                              : '',
                        }"
                      >
                        <label>
                          <input
                            type="radio"
                            name="flag_image"
                            :value="image"
                            v-model="form.pin_type"
                          />
                          <img v-bind:src="buildMarkerIcon(image)" />
                        </label>
                      </div>
                    </dd>
                    <dt>メモ</dt>
                    <dd>
                      <ValidationProvider
                        rules="max:1000"
                        v-slot="ProviderProps"
                      >
                        <textarea v-model="form.remarks"></textarea>
                        <div class="validation-error">
                          {{ ProviderProps.errors[0] }}
                        </div>
                      </ValidationProvider>
                    </dd>
                    <!-- <dt>センサータグ番号</dt>
                    <dd>
                      <input v-model="form.tag_no" type="text" />
                    </dd>
                    <dt>センサー利用<br />開始日</dt>
                    <dd>
                      <input v-model="form.sensor_start_date" type="date" />
                    </dd> -->
                  </template>
                  <template v-else>
                    <dt>名前</dt>
                    <dd>
                      <span>{{ selectedPaddyField.name }}</span>
                    </dd>
                    <dt>位置</dt>
                    <dd>
                      <span>{{ selectedPaddyField.map_pos }}</span>
                    </dd>
                    <dt>面積</dt>
                    <dd>
                      <span v-if="selectedPaddyField.area"
                        >{{ selectedPaddyField.area }}&ensp;a</span
                      >
                      <span v-else>{{ selectedPaddyField.area }}</span>
                    </dd>
                    <dt>品種</dt>
                    <dd>
                      <span>{{ selectedPaddyField.brand }}</span>
                    </dd>
                    <dt>耕作者</dt>
                    <dd>
                      <span>{{ selectedPaddyField.kousakusha }}</span>
                    </dd>
                    <dt>ピンアイコン</dt>
                    <dd>
                      <img
                        v-bind:src="
                          buildMarkerIcon(selectedPaddyField.pin_type)
                        "
                        class="pinicon"
                      />
                    </dd>
                    <dt>メモ</dt>
                    <dd>
                      <span class="textarea">{{
                        selectedPaddyField.remarks
                      }}</span>
                    </dd>
                    <!-- <dt>センサータグ番号</dt>
                    <dd>
                      <span>{{ selectedPaddyField.tag_no }}</span>
                    </dd>
                    <dt>センサー利用<br />開始日</dt>
                    <dd>
                      <span>{{ selectedPaddyField.sensor_start_date }}</span>
                    </dd> -->
                  </template>
                </dl>
              </div>
            </section>

            <div id="button-area" v-if="isCenterFrameEdit">
              <div class="left-box" />
              <div class="center-box">
                <span
                  class="btn btn-submit"
                  :class="{ disable: ObserverProps.invalid }"
                  @click="onSubmit"
                  >保存</span
                >
                <span class="btn btn-cancel" @click="onCancel">キャンセル</span>
              </div>
              <div class="right-box">
                <span
                  class="text"
                  :class="{ active: anyInput }"
                  @click="onDelete"
                  >削除</span
                >
              </div>
            </div>
          </validation-observer>
        </div>
      </transition>
    </div>
    <transition v-if="isShowAreaFrame" name="fade" appear>
      <div class="area-frame-container">
        <div class="area-frame">
          <div class="area-frame-header">
            <h4>ほ場面積</h4>
            <div class="btn-close" @click="hideAreaFrame"></div>
          </div>
          <div class="area-frame-content">
            <!-- <ul>
              <template v-for="(row, index) in areaInfos">
                <li :key="index">{{ row.brand_name }} {{ row.area }} (a)</li>
              </template>
            </ul> -->
            <div style="margin:10px">
              <table>
                <template v-for="(row, index) in areaInfos">
                  <tr :key="index">
                    <td>{{ row.brand_name }}</td>
                    <td class="unit">{{ row.count }}枚</td>
                    <td class="value">{{ row.area | addComma }} (a)</td>
                  </tr>
                </template>
              </table>
            </div>
          </div>
          <div class="area-frame-footer"></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Loader from "@/mixins/loader";
import GoogleMaps from "@/mixins/googlemaps";
import Dialog from "@/mixins/dialog";
import { mapActions, mapGetters } from "vuex";

const CENTER_FRAME_STATUS = { HIDDEN: 0, REFERENCE: 1, EDIT: 2 };

export default {
  mixins: [Loader, GoogleMaps, Dialog],

  data() {
    return {
      markers: [],
      selectedPaddyField: null,
      centerFrameStatus: CENTER_FRAME_STATUS.HIDDEN,
      form: {
        name: null,
        map_pos: null,
        area: null,
        kousakusha: null,
        brand: null,
        brand_id: null,
        pin_type: "ricelog_pinicon_040",
        remarks: null,
        tag_no: null,
        sensor_start_date: null,
      },
      pins: [
        "ricelog_pinicon_010",
        "ricelog_pinicon_020",
        "ricelog_pinicon_030",
        "ricelog_pinicon_040",
        "ricelog_pinicon_050",
        "ricelog_pinicon_060",
        "ricelog_pinicon_070",
        "ricelog_pinicon_080",
        "ricelog_pinicon_090",
        "ricelog_pinicon_100",
      ],
      brands: [],
      selectOptions: [],
      isReadOnly: false,
      isShowAreaFrame: false,
      areaInfos: [],
    };
  },

  computed: {
    anyInput() {
      return Object.keys(this.form).some((key) => {
        if (this.form[key]) {
          return true;
        }
      });
    },

    isCenterFrameHidden() {
      return this.centerFrameStatus === CENTER_FRAME_STATUS.HIDDEN;
    },

    isCenterFrameEdit() {
      return this.centerFrameStatus === CENTER_FRAME_STATUS.EDIT;
    },

    classTitleObject() {
      let iconName = this.selectedPaddyField.pin_type;
      if (!iconName) {
        iconName = "ricelog_pinicon_040";
      }
      return iconName;
    },
  },
  filters: {
    addComma(val) {
      if (!val) {
        return val;
      }
      // 整数部のみカンマをつける
      const vals = val.toString().split(".");
      let ret = vals[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      if (vals.length > 1) {
        ret += "." + vals[1];
      }
      return ret;
    },
  },

  async mounted() {
    this.loading(async () => {
      this.$emit("showMap");
      try {
        // マーカー初期表示
        await this.loadMarkers();
        this.setSelectListener();

        // 品種マスタ
        this.brands = await this.retrieveBrands();
        // ユーザリスト
        await this.listUsers();

        this.isReadOnly = this.isPastManagement();

      } catch (error) {
        console.log(error);
        throw error;
      }
    });
  },

  destroyed() {
    this.clearMarkers();
  },

  methods: {
    ...mapActions([
      "retrievePaddyFields",
      "updatePaddyField",
      "deletePaddyField",
      "retrieveBrands",
      "showUsers",
      "retrievePaddyFieldAreas",
    ]),
    ...mapGetters(["getPaddyFields", "isPastManagement"]),

    hideCenterFrame() {
      this.centerFrameStatus = CENTER_FRAME_STATUS.HIDDEN;
      this.selectedPaddyField = null;
      // フォームデータ初期化
      Object.keys(this.form).forEach((key) => {
        this.form[key] = null;
      });
    },

    async loadMarkers() {
      // 最新の田圃の位置情報を取得
      await this.retrievePaddyFields();
      // 現在マップに残っているマーカーをクリア
      this.clearMarkers();
      // マーカー表示
      this.putMarkers();
    },

    putMarkers() {
      const { Marker } = this.google.maps;
      let paddyFields = this.getPaddyFields();
      paddyFields.forEach((paddyField) => {
        const lat = parseFloat(paddyField.map_pos.split(",")[0]);
        const lng = parseFloat(paddyField.map_pos.split(",")[1]);

        const marker = new Marker({
          position: { lat: lat, lng: lng },
          map: this.map,
        });
        marker.setIcon(this.buildMarkerIconProps(paddyField.pin_type));
        marker.set("paddyField", paddyField);
        this.setInfoWindow(marker, paddyField);
        this.markers.push(marker);
      });
    },

    setInfoWindow(marker, paddyField) {
      var message = [];
      if (paddyField.name) {
        message.push(paddyField.name);
      }
      if (paddyField.area) {
        message.push(paddyField.area + "&nbsp(a)");
      }
      // 品種はマスタの値を表示
      if (paddyField.brand) {
        message.push(paddyField.brand);
      }
      // 耕作者
      if (paddyField.kousakusha) {
        message.push(paddyField.kousakusha);
      }
      var infowin = new this.google.maps.InfoWindow({
        content: message.join("<br>"),
      });

      // mouseoverイベントを取得するListenerを追加
      this.google.maps.event.addListener(marker, "mouseover", function () {
        infowin.open(marker.getMap(), marker);
      });

      // mouseoutイベントを取得するListenerを追加
      this.google.maps.event.addListener(marker, "mouseout", function () {
        infowin.close();
      });
    },

    setSelectListener() {
      this.markers.forEach((marker) => {
        marker.addListener("click", () => {
          this.loading(async () => {
            this.selectedPaddyField = marker.get("paddyField");

            // 田圃詳細を表示する
            this.centerFrameStatus = CENTER_FRAME_STATUS.REFERENCE;
          });
        });
      });
    },

    buildMarkerIconProps(iconName) {
      // アイコンファイル名の組み立て
      let iconProps = { url: this.buildMarkerIcon(iconName) };
      iconProps = Object.assign(iconProps, {
        scaledSize: { width: 24, height: 42 },
        anchor: { x: 12, y: 42 },
      });
      return iconProps;
    },

    buildMarkerIcon(iconName) {
      if (!iconName) {
        iconName = "ricelog_pinicon_040";
      }
      return require("@/assets/pin/" + iconName + ".png");
    },

    clearMarkers() {
      this.markers.forEach((e) => {
        // Mapとの紐付けを解除しイベントリスナーを削除
        e.setMap(null);
        this.google.maps.event.clearInstanceListeners(e);
      });
      this.markers = [];
    },

    onEdit() {
      this.centerFrameStatus = CENTER_FRAME_STATUS.EDIT;

      this.form.name = this.selectedPaddyField.name;
      this.form.map_pos = this.selectedPaddyField.map_pos;
      this.form.area = this.selectedPaddyField.area;
      this.form.kousakusha = this.selectedPaddyField.kousakusha;
      this.form.brand_id = this.selectedPaddyField.brand_id;
      this.form.brand = this.selectedPaddyField.brand;
      // // 品種IDが設定されている場合は、マスタの名称で上書きする
      // if (this.form.brand_id) {
      //   const selectedBrand = this.brands.filter(
      //     (brand) => brand.brand_id === this.form.brand_id
      //   );
      //   if (selectedBrand.length > 0) {
      //     this.form.brand = selectedBrand[0].brand_name;
      //   } else {
      //     // マスタに存在しない場合は、品種IDをクリアする
      //     this.form.brand_id = null;
      //   }
      // }
      this.form.pin_type = this.selectedPaddyField.pin_type;
      this.form.remarks = this.selectedPaddyField.remarks;
      this.form.tag_no = this.selectedPaddyField.tag_no;
      this.form.sensor_start_date = this.selectedPaddyField.sensor_start_date;
    },

    async onCancel() {
      // 田圃詳細を表示する
      this.centerFrameStatus = CENTER_FRAME_STATUS.REFERENCE;
    },

    async onSubmit() {
      this.loading(async () => {
        try {
          const params = {
            paddy_field_id: this.selectedPaddyField.paddy_field_id,
          };
          // 品種IDから品種名を設定
          this.form.brand = null;
          if (this.form.brand_id) {
            const selectedBrand = this.brands.filter(
              (brand) => brand.brand_id === this.form.brand_id
            );
            if (selectedBrand.length > 0) {
              this.form.brand = selectedBrand[0].brand_name;
            }
          }

          Object.assign(params, this.form);

          // 更新
          await this.updatePaddyField(params);

          // 内部データクリア
          this.hideCenterFrame();

          // マーカーをリロード
          await this.loadMarkers();
          this.setSelectListener();
        } catch (error) {
          alert("通信エラー");
          console.log(error);
          throw error;
        }
      });
    },

    async onDelete() {
      this.showConfirm("削除しますか？", async () => {
        this.loading(async () => {
          try {
            const params = {
              paddy_field_ids: [this.selectedPaddyField.paddy_field_id],
            };
            Object.assign(params, this.form);

            // 更新
            await this.deletePaddyField(params);

            // 内部データクリア
            this.hideCenterFrame();

            // マーカーをリロード
            await this.loadMarkers();
            this.setSelectListener();
          } catch (error) {
            alert("通信エラー");
            console.log(error);
            throw error;
          }
        });
      });
    },

    async listUsers() {
      this.selectOptions = [];
      try {
        const Users = await this.showUsers();

        // ユーザデータの整形
        Users.forEach((user) => {
          user.Attributes.forEach((attr) => {
            if (attr.Name === "custom:display_name") {
              this.selectOptions.push(attr.Value);
            }
          });
        });
      } catch (e) {
        console.error(e);
      }
    },
    hideAreaFrame() {
      this.isShowAreaFrame = false;
    },

    async onClickArea() {
      if (this.isShowAreaFrame) {
        this.isShowAreaFrame = false;
        this.areaInfos = [];
      } else {
        this.isShowAreaFrame = true;
        try {
          // 面積
          this.areaInfos = await this.retrievePaddyFieldAreas();
        } catch (e) {
          console.error(e);
        }

      }
    },
  },
};
</script>

<style lang="scss">
$side-frame-width: 350px;

.paddy-field-show {
  &.frame-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  .col1 {
    display: inline-block;
    text-align: center;
    color: var(--col1);
    border: 1px solid var(--col1);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }
  .col1-fill {
    display: inline-block;
    text-align: center;
    color: white;
    background: var(--col1);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }

  .col2 {
    display: inline-block;
    text-align: center;
    color: var(--col2);
    border: 1px solid var(--col2);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }

  .col2-fill {
    display: inline-block;
    text-align: center;
    color: white;
    background: var(--col2);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }

  .col3 {
    display: inline-block;
    text-align: center;
    color: var(--col3);
    border: 1px solid var(--col3);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }
  .col3-fill {
    display: inline-block;
    text-align: center;
    color: white;
    background: var(--col3);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }

  .col4 {
    display: inline-block;
    text-align: center;
    color: var(--col4);
    border: 1px solid var(--col4);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }
  .col4-fill {
    display: inline-block;
    text-align: center;
    color: white;
    background: var(--col4);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }

  .ricelog_pinicon_010 {
    background: url("~@/assets/pin/ricelog_pinicon_010.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_020 {
    background: url("~@/assets/pin/ricelog_pinicon_020.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_030 {
    background: url("~@/assets/pin/ricelog_pinicon_030.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_040 {
    background: url("~@/assets/pin/ricelog_pinicon_040.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_050 {
    background: url("~@/assets/pin/ricelog_pinicon_050.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_060 {
    background: url("~@/assets/pin/ricelog_pinicon_060.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_070 {
    background: url("~@/assets/pin/ricelog_pinicon_070.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_080 {
    background: url("~@/assets/pin/ricelog_pinicon_080.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_090 {
    background: url("~@/assets/pin/ricelog_pinicon_090.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_100 {
    background: url("~@/assets/pin/ricelog_pinicon_100.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  img.pinicon {
    width: 24px;
    height: 42px;
  }

  .image-radio-button {
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
    margin: 2px;
    float: left;
  }
  .image-radio-button:hover {
    background: #eee;
  }
  .image-radio-button img {
    height: 42px;
    width: 24px;
  }
  .image-radio-button label {
    cursor: pointer;
  }

  .center-frame-container {
    position: absolute;
    //   display: none;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.5);
    z-index: 90;

    .center-frame {
      margin: 0;
      padding: 15px 30px;
      width: 80%;
      max-width: 800px;
      //   height: 80vh;
      max-height: 80vh;
      overflow-y: scroll;
      position: absolute;
      top: 10vh;
      background: white;
      border-radius: 20px;
      box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);
      // animation: scaleAnimIn 0.5s;
    }

    //   &.active {
    //     display: flex;
    //     /* animation: scaleAnimIn 0.3s ease-out; */
    //   }

    .title-area {
      width: 100%;
      height: 80px;
      padding: 0;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 1fr 32px;
      align-items: center;
      border-bottom: solid 1px #ddd;
    }

    .title-area h3 {
      margin: 0;
      padding: 0 0 0 10px;
      display: flex;
      align-items: center;
    }

    .title-area h3 span {
      width: 25px;
      height: 45px;
      display: inline-block;
      margin: 0 10px 0 0;
      min-width: 25px;
    }

    .btn-close {
      cursor: pointer;
      width: 32px;
      height: 32px;
      background: url("~@/assets/icons/ic_cancel.svg") no-repeat center center;
      background-size: contain;
    }

    #edit-area {
      display: flex;
      justify-content: flex-end;
      width: 100%;
    }
    #edit-area span {
      display: block;
      font-size: 14px;
      padding: 3px 0px;
      margin: 10px 0;
      text-align: center;
      color: var(--purple);
      border-bottom: solid 4px transparent;
      opacity: 0.5;
      pointer-events: none;
    }

    #edit-area span.active {
      border-bottom: solid 4px var(--purple);
      opacity: 1;
      cursor: pointer;
      pointer-events: inherit;
    }
    #edit-area span.disabled {
      border-bottom: solid 4px var(--purple);
      opacity: 0.5;
      cursor: inherit;
      pointer-events: none;
    }

    #edit-area span::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_edit.svg") no-repeat center center;
      background-size: 20px 20px;
      padding: 0 0 0 15px;
    }

    #button-area {
      display: flex;
      justify-content: flex-start;
      width: 100%;

      .right-box {
        right: 0;
        bottom: 0;
        width: 70px;
      }
      .center-box {
        display: inline;
        text-align: center;
        width: calc(100% - 140px);
      }
      .left-box {
        left: 0;
        bottom: 0;
        width: 70px;
      }

      .btn {
        display: inline-block;
        background: white;
        font-size: 14px;
        text-align: center;
        width: 130px;
        height: 30px;
        border-radius: 15px;
        color: var(--purple);
        padding: 6px 20px;
        margin: 10px auto 10px;
        cursor: pointer;
        &.disable {
          opacity: 0.5;
          cursor: inherit;
          pointer-events: none;
        }
        &.btn-submit {
          background: var(--purple);
          color: #fff;
          margin-left: 3px;
          margin-right: 3px;
        }
        &.btn-cancel {
          background: var(--purple-tertiary);
          color: #000;
          margin-left: 3px;
          margin-right: 3px;
        }
      }

      .text {
        right: 0;
        bottom: 0;
        display: block;
        font-size: 14px;
        padding: 3px 0px;
        margin: 10px 0;
        text-align: center;
        color: var(--purple);
        border-bottom: solid 4px transparent;
        opacity: 0.5;
        pointer-events: none;
      }
      .text.active {
        border-bottom: solid 4px var(--purple-secondary);
        opacity: 1;
        cursor: pointer;
        pointer-events: inherit;
      }
      .text::before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_delete.svg") no-repeat center left;
        background-size: 20px 20px;
        padding: 0 0 0 5px;
      }
    }

    .section {
      overflow: auto;
      width: 100%;
      height: calc(100% - 130px);
      position: relative;

      .container {
        margin: 0;

        dl.columns {
          width: 100%;
          display: grid;
          grid-template-columns: 170px 1fr;
          align-items: top;
          grid-gap: 0px 0px;
          margin: 0;
          padding: 0;
          font-size: 16px;
          color: #333;
        }

        .columns dt {
          display: block;
          text-align: right;
          width: 100%;
          margin: 0;
          padding: 16px;
        }

        .columns dd {
          display: block;
          width: 100%;
          border-left: solid 1px #ddd;
          margin: 0;
          padding: 16px;

          .input-with-unit {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .unit {
              margin-left: 1rem;
              word-break: keep-all;
            }
            input {
              width: auto;
              flex-grow: 2;
            }
          }

          span.textarea {
            white-space: pre-line;
          }
        }
        // .columns dt:nth-of-type(odd) {
        //   background: #f3f3f3;
        // }
        // .columns dd:nth-of-type(odd) {
        //   background: #f3f3f3;
        // }

        /* フォーム */

        input[type="text"],
        input[type="date"],
        input[type="number"] {
          width: 100%;
          height: 40px;
          border-radius: 20px;
          border: solid 1px var(--purple);
          padding: 0 16px;
          font-size: 16px;
          outline: none;
        }

        input[type="text"]:focus,
        input[type="date"]:focus,
        input[type="number"]:focus {
          background: var(--purple-tertiary);
        }

        select {
          width: 100%;
          height: 40px;
          border-radius: 20px;
          border: solid 1px var(--purple);
          padding: 0 38px 0 16px;
          font-size: 16px;
          outline: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
            calc(100% - 10px) center;
          background-size: 25px 25px;
        }

        select:focus {
          background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
            calc(100% - 10px) center var(--purple-tertiary);
          background-size: 25px 25px;
        }

        textarea {
          font-size: 16px;
          width: 100%;
          min-height: 200px;
          white-space: pre-wrap;
          outline: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          border: solid 1px var(--purple);
          padding: 10px;
          border-radius: 10px 10px 0 10px;
          font-family: inherit;
        }

        textarea:focus {
          background: var(--purple-tertiary);
        }

        input[type="radio"] {
          display: none;
        }
        input[type="radio"] + label {
          padding: 0 20px 0 0;
        }
        input[type="radio"]:disabled + label {
          color: #aaa;
        }

        input[type="radio"] + label:before {
          display: inline-block;
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_radio_off.svg") no-repeat center
            left;
          background-size: 24px 24px;
          padding: 0 16px 0 0;
        }
        input[type="radio"]:checked + label:before {
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_radio_on.svg") no-repeat center
            left;
          background-size: 24px 24px;
          display: inline-block;
        }
        input[type="radio"]:disabled + label:before {
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_radio_disabled.svg") no-repeat
            center left;
          background-size: 24px 24px;
          display: inline-block;
        }

        input[type="checkbox"] {
          display: none;
        }
        input[type="checkbox"] + label {
          padding: 0 20px 0 0;
        }

        input[type="checkbox"] + label:before {
          display: inline-block;
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_checkbox_off.svg") no-repeat
            center left;
          background-size: 24px 24px;
          padding: 0 16px 0 0;
        }
        input[type="checkbox"]:checked + label:before {
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_checkbox_on.svg") no-repeat center
            left;
          background-size: 24px 24px;
          display: inline-block;
        }
      }
    }
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .scale-enter,
  .scale-leave-to {
    transform: scale(0.5);
    opacity: 0;
  }
  .scale-enter-active {
    transition: transform 0.25s, opacity 0.25s;
    transition-timing-function: ease-out;
  }
  .scale-leave-active {
    transition: transform 0.25s, opacity 0.25s;
    transition-timing-function: ease-in;
  }
  .filter-area-left {
    display: flex;
    position: absolute;

    .filter-icon-paddy {
      display: block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: white url("~@/assets/icons/ic_filter_paddy.svg") no-repeat
        center center;
      margin: 15px;
      cursor: pointer;
    }
  }
  .area-frame-container {
    position: absolute;
    display: flex;
    margin: 20px;
    // padding: 30px;
    top: 100px;
    // box-sizing: border-box;
    // background: rgba(0, 0, 0, 0.5);
    z-index: 1;
    // background: white;
    // font-size: 0.8rem;
    max-width: 350px;
    // max-height: 50vh;
    min-width: 270px;
    min-height: 100px;

    .area-frame {
      width: 100%;
      padding: 0px;
      background: white;
      box-sizing: border-box;
      border-radius: 20px;
      box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);
    }

    .area-frame-header {
      width: 100%;
      height: 60px;
      padding: 0;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 1fr 50px;
      align-items: center;
      // border-bottom: solid 1px #ddd;
      border-radius: 20px 20px 0 0;
      background: #ddd;
    }

    .area-frame-header h4 {
      font-size: 20px;
      font-weight: bold;
      margin: 0 auto 0;
      padding: 0 0 0 10px;
      display: flex;
      align-items: center;
    }

    .btn-close {
      cursor: pointer;
      width: 24px;
      height: 24px;
      background: url("~@/assets/icons/ic_cancel.svg") no-repeat center center;
      background-size: contain;
    }

    .area-frame-content {
      // margin: 10px 20px;
      font-size: 14px;
      overflow: scroll;
      max-height: calc(100vh - 280px);

      table {
        width: 100%;

        tr {
          line-height: 1.75rem;
          &:nth-of-type(n + 2) {
            border-top: solid 1px darkgray;
          }
        }
        td {
          padding-right: 5px;
        }
        // .label {
        // text-align: right;
        // max-width: 50%;
        // }
        .unit {
          text-align: right;
          white-space: nowrap;
          padding: 0 0 0 10px;
        }
        .value {
          // min-width: 6rem;
          white-space: nowrap;
          text-align: right;
          padding: 0 0 0 10px;
        }
      }
      ul {
        list-style: none;
        padding: 0;
      }
    }

    .area-frame-footer {
      width: 100%;
      height: 40px;
      background: #ddd;
      border-radius: 0 0 20px 20px;
    }
  }

  /* アニメーション */

  @keyframes scaleAnimIn {
    0% {
      display: flex;
      transform: scale(0.5);
    }
    100% {
      display: flex;
      transform: scale(1);
    }
  }

  @keyframes fadeAnimIn {
    0% {
      display: grid;
      opacity: 0;
    }
    100% {
      display: grid;
      opacity: 1;
    }
  }
}
</style>
